import { NavLink, useNavigate } from 'react-router-dom';
import '../assets/styles/dashboard.css';
import { disconnectAgencySocket } from "../utils/socket";


const SidebarMenus = ({
  partnerName = 'Grand Hyatt NYC',
  partnerEmail = 'alex@grandhyatt.com',
  notificationCount = 0,
}) => {
  const navigate = useNavigate();

  const initials = partnerName
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
    //test

    const handleLogout = () => {
      const agencyData = JSON.parse(localStorage.getItem("agencyData") || "{}");
      disconnectAgencySocket(agencyData._id);
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('agencyData');
        localStorage.removeItem('partnerName');
        localStorage.removeItem('partnerEmail');
        navigate('/');
      };

  const menus = [
    { to: '/dashboard', label: 'Dashboard', icon: '⊞' , disable: 'false'},
    { to: '/create-booking', label: 'Create Booking', icon: '＋' , disable: 'false'},
    { to: '/booking-history', label: 'Booking History', icon: '☰' , disable: 'false'},
    { to: '/commissions', label: 'Commissions', icon: '$' , disable: 'true' },
    {
      to: '/notifications',
      label: 'Notifications',
      icon: '🔔',
      disable: 'false',
      badge: notificationCount > 0 ? notificationCount : null,
    },
    { to: '/settings', label: 'Settings', icon: '⚙', disable: 'false' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img
          src={require('../assets/images/logo.png')}
          alt="24x7 Taxi"
          className="sidebar-logo"
        />
        <div>
          <div className="sidebar-brand-title">24×7 Taxi</div>
          <div className="sidebar-brand-sub">Partner Portal</div>
        </div>
      </div>

      <nav className="sidebar-nav">
      {menus.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            `sidebar-link${isActive ? ' active' : ''}${item.disable === 'true' ? ' disabled' : ''}`
          }
          onClick={(e) => {
            if (item.disable === 'true') e.preventDefault();
          }}
          aria-disabled={item.disable === 'true'}
          tabIndex={item.disable === 'true' ? -1 : undefined}
        >
          <span className="sidebar-icon">{item.icon}</span>
          <span>{item.label}</span>
          {item.badge ? <span className="sidebar-badge">{item.badge}</span> : null}
        </NavLink>
      ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{initials}</div>
          <div>
            <div className="sidebar-user-name">{partnerName}</div>
            <div className="sidebar-user-email">{partnerEmail}</div>
          </div>
        </div>
        <button type="button" className="sidebar-logout" onClick={handleLogout}>
          ⟵ Sign Out
        </button>
      </div>
    </aside>
  );
};

export default SidebarMenus;